import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { memo } from 'react';
import { Processing } from '@wg/wows-react-uikit';

import styles from './AnimatedFetchingComponent.module.scss';

const animation = {
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  initial: { opacity: 0 },
  transition: { duration: 0.4 },
};

const animationLoader = {
  ...animation,
  transition: { duration: 0.2 },
};

type IProps = {
  isFetching: boolean;
  isContain?: boolean;
  className?: string;
  children: React.ReactNode;
};

const AnimatedFetchingComponent: React.FC<IProps> = ({ isFetching, className, children, isContain = false }) => {
  return (
    <AnimatePresence>
      {isFetching ? (
        <motion.div {...animationLoader} key={'loader'}>
          <Processing className={classNames(styles.loader, isContain && styles.contain)} isFetching={true} label="" />
        </motion.div>
      ) : (
        <motion.div className={className} {...animation} key={'content'}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default memo(AnimatedFetchingComponent);
